// extracted by mini-css-extract-plugin
export default {"container":"SettingsMenu_container__mMrHY","label":"SettingsMenu_label__SiS56"};